export const CLEAR_PRIOR_STATE = "CLEAR_PRIOR_STATE";
